// types.
export interface Props {
  startAt: string;
  updatedAt?: string;
  country: 'MX' | 'CO';
}

export const ZONE_BY_COUNTRY = {
  MX: 'America/Mexico_City',
  CO: 'America/Bogota',
};

export const msToDuration = (ms: number): Duration => {
  let delta = ms;
  const days = Math.floor(delta / (24 * 60 * 60 * 1000));
  delta -= days * 24 * 60 * 60 * 1000;
  const hours = Math.floor(delta / (60 * 60 * 1000));
  delta -= hours * 60 * 60 * 1000;
  const minutes = Math.floor(delta / (60 * 1000));
  delta -= minutes * 60 * 1000;
  const seconds = Math.floor(delta / 1000);
  return { days, hours, minutes, seconds };
};

export type Duration = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export const pad = (n: number): string => String(n).padStart(2, '0');

const HOURS_TO_MS = (hours: number) => hours * 60 * 60 * 1000;

export const DURATION_THRESHOLDS = {
  warning: HOURS_TO_MS(1),
  danger: HOURS_TO_MS(2),
};

export const getColorFromDuration = (ms: number): string => {
  if (ms >= DURATION_THRESHOLDS.danger) return '#dc3545'; // red
  if (ms >= DURATION_THRESHOLDS.warning) return 'orange';
  return 'green';
};
